import imageto3d from './assert/imageti3d.webp'
import hqdefault1 from './assert/hqdefault1.jpg'
import hqdefault2 from './assert/hqdefault2.jpg'
import hqdefault3 from './assert/hqdefault3.jpg'
import hqdefault4 from './assert/hqdefault4.jpg'
import hqdefault5 from './assert/hqdefault5.jpg'
import hqdefault6 from './assert/hqdefault6.jpg'
import hqdefault7 from './assert/hqdefault7.jpg'
import hqdefault8 from './assert/hqdefault8.jpg'
import hqdefault9 from './assert/hqdefault9.jpg'
import hqdefault10 from './assert/hqdefault10.jpg'
import mqdefault_6s from './assert/mqdefault_6s.webp'
import visionpro from './assert/visionpro.jpg'
import rodin from './assert/rodin.jpg'
import Course1 from './assert/chineseCourse1.webp'
import Course2 from './assert/chineseCourse2.webp'
import Course3 from './assert/chineseCourse3.webp'
import Course4 from './assert/chineseCourse4.webp'
import Course5 from './assert/chineseCourse5.webp'
import Course6 from './assert/chineseCourse6.webp'
import Course7 from './assert/chineseCourse7.jpg'
import Course8 from './assert/chineseCourse8.jpg'


export const collectionData = {
  chinese: [{
    title: "ChatAvatar介绍",
    update_time: '',
    coverimg: Course1,
    arrData: [
      {
        src: Course1,
        title: "ChatAvatar介绍第一期：生成数字角色的两种方法",
        duration: '2:37',
        message: "",
        href: 'https://www.youtube.com/watch?v=l4yo2ln-DEQ',
        iframe: "https://www.youtube.com/embed/l4yo2ln-DEQ?si=DD2aiGLaJG_piX4z",
      },
      {
        src: Course2,
        title: "ChatAvatar介绍第二期：下载与打包",
        duration: '3:06',
        message: "",
        href: 'https://www.youtube.com/watch?v=CbOtRd8A0oM',
        iframe: "https://www.youtube.com/embed/CbOtRd8A0oM?si=A2E_C09wODPXEsMv",
      },
      {
        src: Course3,
        title: "ChatAvatar介绍第三期：如何将数字角色模型导入虚幻引擎",
        duration: '3:02',
        message: "",
        href: 'https://www.youtube.com/watch?v=Q25tgGGmS1E',
        iframe: "https://www.youtube.com/embed/61SaTYQpmq0?si=6Ai-tFponRG4MwRF",
      },
      {
        src: Course4,
        title: "ChatAvatar介绍第四期：如何利用插件将数字人导入CocosCreator",
        duration: '3:02',
        message: "",
        href: 'https://www.youtube.com/watch?v=16qUaLcDwnI',
        iframe: "https://www.youtube.com/embed/16qUaLcDwnI?si=Mo9eiyC6Ex9vTwNR",
      },
      {
        src: Course5,
        title: "ChatAvatar介绍第五期：如何利用插件ChatAvatarImportTool将数字人导入Blender并用Cycles渲染",
        duration: '2:27',
        message: "",
        href: 'https://www.youtube.com/watch?v=vexnAHqbm2E',
        iframe: "https://www.youtube.com/embed/vexnAHqbm2E?si=NqDmBsDlitEwug68",
      },
      {
        src: Course6,
        title: "ChatAvatar介绍第六期：如何使用插件将数字人导入Unity",
        duration: '2:46',
        message: "",
        href: 'https://www.youtube.com/watch?v=8gnFOmsuxIc',
        iframe: "https://www.youtube.com/embed/8gnFOmsuxIc?si=d9rdWasG_imIT-dZ",
      },
      {
        src: Course7,
        title: "ChatAvatar介绍第七期：如何使用插件将数字人导入Maya场景",
        duration: '1:53',
        message: "",
        href: 'https://www.youtube.com/watch?v=j-TNqkIZyrk',
        iframe: "https://www.youtube.com/embed/j-TNqkIZyrk?si=tDLIPR2NGqYoQpUl",
      },
      {
        src: Course8,
        title: "ChatAvatar介绍第八期：如何使用插件将数字人导入Omniverse",
        duration: '2:58',
        message: "",
        href: 'https://www.youtube.com/watch?v=2Q1omZTwJj0',
        iframe: "https://www.youtube.com/embed/2Q1omZTwJj0?si=4VJ0Kd8vOgfYkJS6",
      },
    ]
  }],
  english: [{
    title: "Introduction to ChatAvatar",
    update_time: "4 days ago",
    coverimg: Course1,
    arrData: [
      {
        src: Course1,
        title: "Introduction to ChatAvatar - Part 1: Two Methods of Generating an Avatar",
        duration: '2:54',
        message: "",
        href: 'https://www.youtube.com/watch?v=gyuk1FAaqoE',
        iframe: "https://www.youtube.com/embed/gyuk1FAaqoE?si=_neMxEeM6ygOw4_N"

      },
      {
        src: Course2,
        title: "Introduction to ChatAvatar - Part 2: Downloading and Packaging the Generated Avatar",
        duration: '3:03',
        message: "",
        href: 'https://www.youtube.com/watch?v=DlYOnZk6HYE',
        iframe: "https://www.youtube.com/embed/DlYOnZk6HYE?si=oSx27iejAN0Ka3le"

      },
      {
        src: Course3,
        title: "Introduction to ChatAvatar - Part 3: How to Import Avatar Models into Unreal Engine",
        duration: '3:17',
        message: "",
        href: 'https://www.youtube.com/watch?v=qswGfTAj65Q',
        iframe: "https://www.youtube.com/embed/qswGfTAj65Q?si=IIFNepvRcQMk4n58"
      },
      {
        src: Course4,
        title: "Introduction to ChatAvatar - Part 4: How to import digital avatars into CocosCreator using plugins",
        duration: '3:00',
        message: "",
        href: 'https://www.youtube.com/watch?v=EZn1cRC9FqY',
        iframe: "https://www.youtube.com/embed/EZn1cRC9FqY?si=GMoEra09nAlALZIG",
      },
      {
        src: Course5,
        title: "Introduction to ChatAvatar - Part 5: How to import avatars into Blender using ChatAvatarImportTool",
        duration: '2:28',
        message: "",
        href: 'https://www.youtube.com/watch?v=3LukkItV2tc',
        iframe: "https://www.youtube.com/embed/3LukkItV2tc?si=5TwaXKf4dYMhixPR",
      },
      {
        src: Course6,
        title: "Introduction to ChatAvatar - Part 6: How to import avatars into Unity using ChatAvatarImportTool",
        duration: '2:46',
        message: "",
        href: 'https://www.youtube.com/watch?v=jGUoLoFlCfw',
        iframe: "https://www.youtube.com/embed/jGUoLoFlCfw?si=eGugsvkHfqok916f",
      },
      {
        src: Course7,
        title: "Introduction to ChatAvatar–Part 7: How to import avatars into Maya with plugin ChatAvatarImportTool",
        duration: '1:05',
        message: "",
        href: 'https://www.youtube.com/watch?v=UNjx41-F1xc',
        iframe: "https://www.youtube.com/embed/UNjx41-F1xc?si=36CC_uvbFMheUeV5",
      },
      {
        src: Course8,
        title: "Introduction to ChatAvatar–Part 8: How to import avatars into Omniverse",
        duration: '3:12',
        message: "",
        href: 'https://www.youtube.com/watch?v=EDJHX4hMMWA&t=73s',
        iframe: "https://www.youtube.com/embed/EDJHX4hMMWA?si=TjcNRDFsvTblqoeU",
      },
    ]
  }]
}


// export const mockData = {
//   chinese:[
//     {
//       src: imageto3d,
//       title: "",
//       duration: '0:59',
//       message: "548次观看· 1个月前",
//       href: 'https://www.youtube.com/watch?v=NU_JdonzDLU',
//       iframe: "https://www.youtube.com/embed/NU_JdonzDLU?si=9AZsaz-JdSaSH_Di"

//     },
//     {
//       src: mqdefault_6s,
//       title: "",
//       duration: '8:01',
//       message: "14次观看· 3天前",
//       href: 'https://www.youtube.com/watch?v=Q25tgGGmS1E',
//       iframe: "https://www.youtube.com/embed/Q25tgGGmS1E?si=OBUPEy3LRaxoyMnR"

//     },
//     {
//       src: hqdefault1,
//       title: "",
//       duration: '2:42',
//       message: "136次观看· 5个月前",
//       href: 'https://www.youtube.com/watch?v=F_hScVkNBsg',
//       iframe: "https://www.youtube.com/embed/F_hScVkNBsg?si=rVoTXroXq2Otxmf6"

//     },

//     {
//       src: hqdefault2,
//       title: "",
//       duration: '4:05',
//       message: "200 次观看· 5个月前",
//       href: 'https://www.youtube.com/watch?v=YSAXOG1MpYc',
//       iframe: "https://www.youtube.com/embed/YSAXOG1MpYc?si=EZf5z-5zeHl3VVE4"
//     },

//     {
//       src: hqdefault3,
//       title: "",
//       duration: '0:42',
//       message: "235次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=n1Wgy_Lg3Gg',
//       iframe: "https://www.youtube.com/embed/n1Wgy_Lg3Gg?si=kqyySA1NDUrUKYiL"
//     },

//     {
//       src: hqdefault4,
//       title: "",
//       duration: '0:31',
//       message: "79次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=z2gphdpRxuI',
//       iframe: "https://www.youtube.com/embed/z2gphdpRxuI?si=XhVmgrJf1pjBDj8s"

//     },

//     {
//       src: hqdefault5,
//       title: "",
//       duration: '1:05',
//       message: "57次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=nzYKLsTAsiQ',
//       iframe: "https://www.youtube.com/embed/nzYKLsTAsiQ?si=2poN992tI8ZQBmzr"
//     },

//     {
//       src: hqdefault6,
//       title: "",
//       duration: '1:04',
//       message: "46次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=RMhMEz35fME',
//       iframe: "https://www.youtube.com/embed/RMhMEz35fME?si=d4wbpDvu4QypfXdV"
//     },

//     {
//       src: hqdefault7,
//       title: "",
//       duration: '0:42',
//       message: "27次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=2R6YGV-Zba4',
//       iframe: "https://www.youtube.com/embed/2R6YGV-Zba4?si=8nbarUPh8tpsLH53"
//     },

//     {
//       src: hqdefault8,
//       title: "",
//       duration: '0:45',
//       message: "718次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=waXg9rp3QGU',
//       iframe: "https://www.youtube.com/embed/waXg9rp3QGU?si=nKCoDiBeV1ZzVVMq"
//     },

//     {
//       src: hqdefault9,
//       title: "",
//       duration: '0:05',
//       message: "46 次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=ZIIGnj5kD1M',
//       iframe: "https://www.youtube.com/embed/ZIIGnj5kD1M?si=VXKeYuvCux7EjKC6"
//     },

//     {
//       src: hqdefault10,
//       title: "",
//       duration: '0:48',
//       message: "265次观看· 6个月前",
//       href: 'https://www.youtube.com/watch?v=haV-ec8Wykg',
//       iframe: "https://www.youtube.com/embed/haV-ec8Wykg?si=8MW72ZvK_Sd0gq21"
//     }
//   ],
//   english:[
//     {
//       src: imageto3d,
//       title: "Introducing ChatAvatar: Text / Image to 3D Avatar",
//       duration: '0:59',
//       message: "548 views · 1 months ago",
//       href: 'https://www.youtube.com/watch?v=NU_JdonzDLU',
//       iframe: "https://www.youtube.com/embed/NU_JdonzDLU?si=9AZsaz-JdSaSH_Di"

//     },
//     {
//       src: mqdefault_6s,
//       title: "Intro to ChatAvatar at SIGGRAPH 2023 Real-time Live!",
//       duration: '8:01',
//       message: "14 views · 3 days ago",
//       href: 'https://www.youtube.com/watch?v=Q25tgGGmS1E',
//       iframe: "https://www.youtube.com/embed/Q25tgGGmS1E?si=OBUPEy3LRaxoyMnR"

//     },
//     {
//       src: hqdefault1,
//       title: "[Deemos Research] HACK on SIGGRAPH 2023",
//       duration: '2:42',
//       message: "136 views · 5 months ago",
//       href: 'https://www.youtube.com/watch?v=F_hScVkNBsg',
//       iframe: "https://www.youtube.com/embed/F_hScVkNBsg?si=rVoTXroXq2Otxmf6"

//     },

//     {
//       src: hqdefault2,
//       title: "Technology Behind ChatAvatar: DreamFace",
//       duration: '4:05',
//       message: "200 views · 5 months ago",
//       href: 'https://www.youtube.com/watch?v=YSAXOG1MpYc',
//       iframe: "https://www.youtube.com/embed/YSAXOG1MpYc?si=EZf5z-5zeHl3VVE4"
//     },

//     {
//       src: hqdefault3,
//       title: "Chat Avatar",
//       duration: '0:42',
//       message: "235 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=n1Wgy_Lg3Gg',
//       iframe: "https://www.youtube.com/embed/n1Wgy_Lg3Gg?si=kqyySA1NDUrUKYiL"
//     },

//     {
//       src: hqdefault4,
//       title: "Deemos Scan and Makeup Demo",
//       duration: '0:31',
//       message: "79 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=z2gphdpRxuI',
//       iframe: "https://www.youtube.com/embed/z2gphdpRxuI?si=XhVmgrJf1pjBDj8s"

//     },

//     {
//       src: hqdefault5,
//       title: "Deemos Reconstruction Demo",
//       duration: '1:05',
//       message: "57 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=nzYKLsTAsiQ',
//       iframe: "https://www.youtube.com/embed/nzYKLsTAsiQ?si=2poN992tI8ZQBmzr"
//     },

//     {
//       src: hqdefault6,
//       title: "Deemos Relighting Demo",
//       duration: '1:04',
//       message: "46 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=RMhMEz35fME',
//       iframe: "https://www.youtube.com/embed/RMhMEz35fME?si=d4wbpDvu4QypfXdV"
//     },

//     {
//       src: hqdefault7,
//       title: "Deemos Wand",
//       duration: '0:42',
//       message: "27 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=2R6YGV-Zba4',
//       iframe: "https://www.youtube.com/embed/2R6YGV-Zba4?si=8nbarUPh8tpsLH53"
//     },

//     {
//       src: hqdefault8,
//       title: "Deemos Chat Avatar",
//       duration: '0:45',
//       message: "718 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=waXg9rp3QGU',
//       iframe: "https://www.youtube.com/embed/waXg9rp3QGU?si=nKCoDiBeV1ZzVVMq"
//     },

//     {
//       src: hqdefault9,
//       title: "Deemos OLAT LookDev",
//       duration: '0:05',
//       message: "46 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=ZIIGnj5kD1M',
//       iframe: "https://www.youtube.com/embed/ZIIGnj5kD1M?si=VXKeYuvCux7EjKC6"
//     },

//     {
//       src: hqdefault10,
//       title: "Deemos Text-to-avatar",
//       duration: '0:48',
//       message: "265 views · 6 months ago",
//       href: 'https://www.youtube.com/watch?v=haV-ec8Wykg',
//       iframe: "https://www.youtube.com/embed/haV-ec8Wykg?si=8MW72ZvK_Sd0gq21"
//     }
//   ],
// }

export const mockData = [
  {
    src: rodin,
    title: "Rodin Gen-1 is now open trials at http://hyper3d.ai/rodin",
    duration: '0:39',
    message: "",
    href: 'https://www.youtube.com/watch?v=YvB8wk_wJ6E',
    iframe: "https://www.youtube.com/embed/YvB8wk_wJ6E?si=Yi1Rb2HeF6BWS2-h"

  },
  {
    src: visionpro,
    title: "Use VisionPro with Rodin Gen-1 image to 3D to create anything!",
    duration: '0:30',
    message: "",
    href: 'https://www.youtube.com/watch?v=5yaywtShXsk',
    iframe: "https://www.youtube.com/embed/5yaywtShXsk?si=3LWk6DuUJRFtejDO"

  },
  {
    src: imageto3d,
    title: "Introducing ChatAvatar: Text / Image to 3D Avatar",
    duration: '0:59',
    message: "",
    href: 'https://www.youtube.com/watch?v=NU_JdonzDLU',
    iframe: "https://www.youtube.com/embed/NU_JdonzDLU?si=9AZsaz-JdSaSH_Di"

  },
  {
    src: mqdefault_6s,
    title: "Intro to ChatAvatar at SIGGRAPH 2023 Real-time Live!",
    duration: '8:01',
    message: "",
    href: 'https://www.youtube.com/watch?v=Q25tgGGmS1E',
    iframe: "https://www.youtube.com/embed/Q25tgGGmS1E?si=OBUPEy3LRaxoyMnR"

  },
  {
    src: hqdefault1,
    title: "[Deemos Research] HACK on SIGGRAPH 2023",
    duration: '2:42',
    message: "",
    href: 'https://www.youtube.com/watch?v=F_hScVkNBsg',
    iframe: "https://www.youtube.com/embed/F_hScVkNBsg?si=rVoTXroXq2Otxmf6"

  },

  {
    src: hqdefault2,
    title: "Technology Behind ChatAvatar: DreamFace",
    duration: '4:05',
    message: "",
    href: 'https://www.youtube.com/watch?v=YSAXOG1MpYc',
    iframe: "https://www.youtube.com/embed/YSAXOG1MpYc?si=EZf5z-5zeHl3VVE4"
  },

  {
    src: hqdefault3,
    title: "Chat Avatar",
    duration: '0:42',
    message: "",
    href: 'https://www.youtube.com/watch?v=n1Wgy_Lg3Gg',
    iframe: "https://www.youtube.com/embed/n1Wgy_Lg3Gg?si=kqyySA1NDUrUKYiL"
  },

  {
    src: hqdefault4,
    title: "Deemos Scan and Makeup Demo",
    duration: '0:31',
    message: "",
    href: 'https://www.youtube.com/watch?v=z2gphdpRxuI',
    iframe: "https://www.youtube.com/embed/z2gphdpRxuI?si=XhVmgrJf1pjBDj8s"

  },

  {
    src: hqdefault5,
    title: "Deemos Reconstruction Demo",
    duration: '1:05',
    message: "",
    href: 'https://www.youtube.com/watch?v=nzYKLsTAsiQ',
    iframe: "https://www.youtube.com/embed/nzYKLsTAsiQ?si=2poN992tI8ZQBmzr"
  },

  {
    src: hqdefault6,
    title: "Deemos Relighting Demo",
    duration: '1:04',
    message: "",
    href: 'https://www.youtube.com/watch?v=RMhMEz35fME',
    iframe: "https://www.youtube.com/embed/RMhMEz35fME?si=d4wbpDvu4QypfXdV"
  },

  {
    src: hqdefault7,
    title: "Deemos Wand",
    duration: '0:42',
    message: "",
    href: 'https://www.youtube.com/watch?v=2R6YGV-Zba4',
    iframe: "https://www.youtube.com/embed/2R6YGV-Zba4?si=8nbarUPh8tpsLH53"
  },

  {
    src: hqdefault8,
    title: "Deemos Chat Avatar",
    duration: '0:45',
    message: "",
    href: 'https://www.youtube.com/watch?v=waXg9rp3QGU',
    iframe: "https://www.youtube.com/embed/waXg9rp3QGU?si=nKCoDiBeV1ZzVVMq"
  },

  {
    src: hqdefault9,
    title: "Deemos OLAT LookDev",
    duration: '0:05',
    message: "",
    href: 'https://www.youtube.com/watch?v=ZIIGnj5kD1M',
    iframe: "https://www.youtube.com/embed/ZIIGnj5kD1M?si=VXKeYuvCux7EjKC6"
  },

  {
    src: hqdefault10,
    title: "Deemos Text-to-avatar",
    duration: '0:48',
    message: "",
    href: 'https://www.youtube.com/watch?v=haV-ec8Wykg',
    iframe: "https://www.youtube.com/embed/haV-ec8Wykg?si=8MW72ZvK_Sd0gq21"
  }
]